export default [
    {
        path: '/website/page/:id/device-preview',
        props: false,
        component: () => import('@/views/WebsitePage/Preview'),
    },
];
